/* eslint-disable */
export default ['应用下载API--激活', '应用下载API--激活,付费', '应用下载SDK--激活', '应用下载SDK--激活,付费']
